import { render } from "./StafetLysPoserList.vue?vue&type=template&id=b48bfba2"
import script from "./StafetLysPoserList.vue?vue&type=script&lang=js"
export * from "./StafetLysPoserList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__